import { useMemo, useEffect, useState } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import { useTranslation } from 'react-i18next';
import { Divider, Grid } from "@mui/material";
import chartImage from "assets/images/Chart/hc-chart-si.jpg";

function HCViewAstakaWargaya({ astakaWargaData }) {
    const positions = [
        { top: "12%", left: "38%" },
        { top: "12%", left: "60%" },
        { top: "12%", left: "85%" },
        { top: "37%", left: "85%" },
        { top: "60%", left: "85%" },
        { top: "88%", left: "85%" },
        { top: "88%", left: "63%" },
        { top: "88%", left: "38%" },
        { top: "88%", left: "12%" },
        { top: "63%", left: "12%" },
        { top: "38%", left: "12%" },
        { top: "12%", left: "12%" },
    ];
    const { t } = useTranslation();
    const imageUrl = ('/assets/images/Chart/hc-chart-si.jpg')//"/Content/Images/Chart/hc-chart-si.jpg";

    return (
        <>
            {/* <MDBox p={3} lineHeight={1} mb={0} display="flex" alignItems="center">
                <MDTypography variant="h5" fontWeight="medium">
                    අෂ්ටකවර්ගය
                </MDTypography>
                <Divider variant="fullWidth" sx={{ flexGrow: 1, marginLeft: 2 }} />
            </MDBox> */}
            <Grid container mt={1} ml={0} pl={1} spacing={4}>
                {astakaWargaData.map((item, i) => (
                    <Grid key={"er" + i} item style={{ paddingTop: 4, marginBottom: 3, pageBreakInside: "avoid" }} xs={12} md={6} xl={4}>

                        <MDBox
                            position="relative"
                            width={300}
                            height={300}
                            sx={{
                                // backgroundImage: "url(${chartImage})",
                                backgroundSize: "300px 300px",
                            }}
                        >

                            {/* Overlay image */}
                            <MDBox
                                position="relative"
                                width="100%"
                                height="100%"
                                sx={{
                                    backgroundImage: `url(${chartImage})`,
                                    backgroundRepeat: "no-repeat",
                                    backgroundSize: "300px 300px",
                                    opacity: 0.93,
                                }}
                            >
                                {/* Center name */}
                                <MDBox
                                    position="absolute"
                                    top="50%"
                                    left="52%"
                                    sx={{
                                        transform: "translate(-50%, -50%)",
                                        textAlign: "center",
                                    }}
                                >
                                    <MDTypography variant="body2" fontWeight="bold">
                                        {item.name}
                                        <br />
                                        <MDTypography variant="caption" component="span">
                                            {t("AstakaWargaya")}
                                        </MDTypography>
                                    </MDTypography>
                                </MDBox>

                                {/* 12 surrounding marks */}
                                {item.marks?.map((mark, j) => (
                                    <MDBox
                                        key={"" + i + "" + j}
                                        position="absolute"
                                        sx={{
                                            ...positions[j],
                                            transform: "translate(-50%, -50%)",
                                            textAlign: "center",
                                        }}
                                    >
                                        {mark && (
                                            <>
                                                <MDTypography style={{ position: "absolute", top: "-24px", left: "24px" }} variant="body2" fontWeight="medium">
                                                    {j == 0 && <i className="material-icons" style={{ fontSize: "12px" }}>arrow_right</i>}
                                                </MDTypography>

                                                <MDTypography variant="body2" fontWeight="medium">
                                                    <span title={j + 1} style={{ cursor: "default" }}>{mark}</span>
                                                </MDTypography>
                                            </>
                                        )}
                                    </MDBox>
                                ))}
                            </MDBox>
                        </MDBox>
                    </Grid>
                ))}
            </Grid>
        </>
    )
}

HCViewAstakaWargaya.propTypes = {
    astakaWargaData: PropTypes.array,
};

export default HCViewAstakaWargaya;